import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    headingSection: {
        //...contentBlockStyles(theme).headingSection,
        marginBottom: theme.isFlyingFlowers ? spacing.large : spacing.medium,
        [theme.breakpoints.up('md')]: {
            marginBottom: theme.isFlyingFlowers ? spacing.xl : spacing.medium,
        },
        '& h3': Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.none), { marginBottom: spacing.medium, [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xl_regular), theme.typographySpacing.none), { marginBottom: spacing.large }) }),
        '& $message, & p': Object.assign(Object.assign({}, theme.typography.small_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.medium_regular) }),
        '& p': Object.assign(Object.assign({ marginBottom: spacing.small }, theme.typography.small_regular), { padding: theme.isFlyingFlowers ? undefined : 0, [theme.breakpoints.up('md')]: Object.assign(Object.assign({ marginBottom: spacing.medium }, theme.typography.medium_regular), { padding: theme.isFlyingFlowers ? undefined : 0 }), '&:last-child': {
                marginBottom: 0,
            } }),
    },
    title: Object.assign(Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xl_regular : theme.typography.medium_bold)), (theme.isFlyingFlowers ? theme.typographySpacing.xl_regular_lg : theme.typographySpacing.none)), { marginBottom: spacing.medium, padding: theme.isFlyingFlowers ? undefined : 0, [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xl_regular), (theme.isFlyingFlowers ? theme.typographySpacing.xxl_lg : theme.typographySpacing.none)), { marginBottom: spacing.medium, padding: theme.isFlyingFlowers ? undefined : 0 }) }),
    productGrid: {
        flexGrow: 1,
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    message: {},
    gallery: {
        textAlign: 'center',
    },
    error: { marginBottom: spacing.small },
}));
export default useStyles;
